export const YEAR_MONTH_DAY = 'YYYY-MM-DD';
export const TIME_OF_DAY = 'HH:mm:ss';
export const DATE_TIME_FORMAT = 'YYYY-MM-DDTHH:mmZZ';
